import React from 'react';
import styled from 'styled-components';
import { Selected } from '../../features/common/atoms';
import { compose, withState, withHandlers, withProps } from 'recompose';
import i18next from 'i18next';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const filterItems = (items, search) => {
  const regexp = new RegExp(String(search).toLowerCase());

  return items.reduce((acc, item) => {
    const match = String(item.name)
      .toLowerCase()
      .match(regexp);
    const name = item.name;
    if (match && match[0] === '') {
      acc.push({ ...item, _name: name });
    } else if (match) {
      acc.push({
        ...item,
        name: (
          <React.Fragment>
            {name.slice(0, match.index)}
            <Selected>{name.slice(match.index, match.index + search.length)}</Selected>
            {name.slice(match.index + search.length)}
          </React.Fragment>
        ),
        _name: name,
      });
    }

    return acc;
  }, []);
};

export const withSearch = (fields, output) =>
  compose(
    withState('searchString', 'setSearchString', ''),
    withHandlers({
      onSearch: ({ setSearchString }) => (event) => {
        setSearchString(event.target.value);
      },
    }),
    withProps((props) => {
      const { searchString, ...restProps } = props;
      let searchResult;
      searchResult = fields.reduce((acc, field, index) => {
        const data = props[field] || [];

        acc[output[index]] = filterItems(data, searchString);

        return acc;
      }, {});

      return {
        searchString,
        ...searchResult,
        ...restProps,
      };
    })
  );

export const Search = ({ onSubmit, ...restProps }) => (
  <Form onSubmit={onSubmit}>
    <SearchInput {...restProps} placeholder={i18next.t('Поиск')} />
    <Submit type="submit" disabled />
  </Form>
);

const SearchInput = styled.input`
  height: 48px;
  width: 468px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid ${Colors.whisper};
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-left: 20px;
  padding-right: 48px;
`;
const Form = styled.form`
  position: relative;
  height: 48px;
  width: 468px;
`;
const Submit = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 48px;
  height: 48px;
  background: transparent;
  border: none;
  cursor: ${(p) => !p.disabled && 'pointer'};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3Cpath fill='%239B9B9B' d='M14.86 13.446l7.847 7.847-1.414 1.414-7.973-7.973a8 8 0 1 1 1.54-1.288zM9 14A6 6 0 1 0 9 2a6 6 0 0 0 0 12z'/%3E%3C/g%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: center center;
`;
